const hi = {
  getHelp: {
    title: 'सहायता और समर्थन प्राप्त करें',
    subtitle: 'सहायता की आवश्यकता है? हमारी टीम आपकी मदद के लिए यहाँ है। फोन, ईमेल या लाइव चैट के माध्यम से संपर्क करें, या नीचे हमारे FAQ ब्राउज़ करें।',
    contactInfo: 'संपर्क जानकारी',
    faq: 'अक्सर पूछे जाने वाले प्रश्न',
    faqSubtitle: 'सामान्य प्रश्नों के उत्तर खोजें',
    emergency: 'आपातकाल',
    emergencyDesc: 'तत्काल सुरक्षा चिंताओं के लिए',
    support: 'समर्थन',
    supportDesc: 'सामान्य प्रश्न और सहायता',
    technical: 'तकनीकी',
    technicalDesc: 'ऐप और वेबसाइट समस्याएं',
    phone: 'फोन',
    email: 'ईमेल',
    chat: 'लाइव चैट',
    available: '24/7 उपलब्ध',
    responseTime: '2 घंटे के भीतर प्रतिक्रिया',
    responseTimeLong: '24 घंटे के भीतर प्रतिक्रिया',
  },
  myIssues: {
    title: 'मेरे मुद्दे और शिकायतें',
    subtitle: 'अपनी रिपोर्ट किए गए मुद्दों और शिकायतों की स्थिति ट्रैक करें। तत्काल सहायता के लिए, कृपया सहायता प्राप्त करें अनुभाग का उपयोग करें।',
    noIssues: 'कोई शिकायत या मुद्दा नहीं मिला।',
    noIssuesDesc: 'यदि आपको सहायता की आवश्यकता है, तो कृपया सहायता प्राप्त करें अनुभाग का उपयोग करें या नई समस्या रिपोर्ट करें।',
    issueId: 'समस्या आईडी',
    priority: 'प्राथमिकता',
    status: 'स्थिति',
    subject: 'विषय',
    type: 'प्रकार',
    filedOn: 'दाखिल किया गया',
    inProgress: 'प्रगति में',
    resolved: 'समाधान किया गया',
    closed: 'बंद',
    high: 'उच्च',
    medium: 'मध्यम',
    low: 'कम',
    loading: 'लोड हो रहा है...',
    error: 'मुद्दे लोड करने में त्रुटि',
  },
  reportIssue: {
    title: 'समस्या रिपोर्ट करें',
    subtitle: 'कोई समस्या आ रही है? कृपया नीचे फॉर्म भरें और हमारी सहायता टीम 24-48 घंटों के भीतर आपसे संपर्क करेगी।',
    selectOption: 'एक विकल्प चुनें',
    selectIssueType: 'समस्या का प्रकार चुनें',
    selectUrgency: 'तात्कालिकता चुनें',
    beforeSubmit: 'सबमिट करने से पहले:',
    beforeSubmitPoints: [
      'तत्काल सुरक्षा चिंताओं के लिए, कृपया आपातकालीन सेवाओं को कॉल करें',
      'अपनी सवारी रसीद और कोई प्रासंगिक स्क्रीनशॉट रखें',
      'हम 24-48 घंटों के भीतर जवाब देंगे'
    ],
    submitIssue: 'समस्या रिपोर्ट सबमिट करें',
    submitting: 'सबमिट हो रहा है...',
    success: 'आपकी समस्या सफलतापूर्वक सबमिट कर दी गई है! हमारी सहायता टीम जल्द ही इसका समाधान करेगी।',
    error: 'कुछ गलत हो गया। कृपया बाद में पुनः प्रयास करें।',
    loading: 'लोड हो रहा है...',
  },
  common: {
    loading: 'लोड हो रहा है...',
    error: 'त्रुटि',
    success: 'सफलता',
    submit: 'सबमिट करें',
    cancel: 'रद्द करें',
    back: 'वापस',
    next: 'अगला',
    save: 'सहेजें',
    edit: 'संपादित करें',
    delete: 'हटाएं',
    close: 'बंद करें',
    open: 'खोलें',
    yes: 'हाँ',
    no: 'नहीं',
    required: 'आवश्यक',
    optional: 'वैकल्पिक',
  },
  aboutYou: {
    basicInfo: "मूल जानकारी",
    firstName: "पहला नाम",
    lastName: "अंतिम नाम",
    gender: "लिंग",
    male: "पुरुष",
    female: "महिला",
    other: "अन्य",
    preferNotToSay: "कहना नहीं चाहते",
    dateOfBirth: "जन्म तिथि",
    contactInfo: "संपर्क जानकारी",
    email: "ईमेल पता",
    phoneNumber: "फोन नंबर",
    addressInfo: "पता जानकारी",
    address: "पता",
    city: "शहर",
    state: "राज्य",
    pincode: "पिन कोड",
    emergencyContact: "आपातकालीन संपर्क",
    emergencyContactNumber: "संपर्क नंबर",
    relationship: "रिश्ता",
    selectRelationship: "रिश्ता चुनें",
    parent: "माता-पिता",
    spouse: "पति/पत्नी",
  
    saveProfile: "प्रोफ़ाइल जानकारी सहेजें",
    phFirstName: "पहला नाम दर्ज करें",
    phLastName: "अंतिम नाम दर्ज करें",
    phEmail: "ईमेल पता दर्ज करें",
    phPhone: "फोन नंबर दर्ज करें",
    phAddress: "अपना पता दर्ज करें",
    phCity: "शहर दर्ज करें",
    phState: "राज्य दर्ज करें",
    phPincode: "पिन कोड दर्ज करें",
    phEmergencyContact: "आपातकालीन संपर्क नंबर दर्ज करें",
    save: 'सेव करें',
    edit: 'संपादित करें',
    firstNameRequired: 'पहला नाम आवश्यक है।',
    firstNameInvalid: 'पहला नाम केवल अक्षरों, स्पेस, अपॉस्ट्रॉफी या हाइफ़न में होना चाहिए।',
    lastNameRequired: 'अंतिम नाम आवश्यक है।',
    lastNameInvalid: 'अंतिम नाम केवल अक्षरों, स्पेस, अपॉस्ट्रॉफी या हाइफ़न में होना चाहिए।',
    emailRequired: 'ईमेल आवश्यक है।',
    emailInvalid: 'कृपया एक मान्य ईमेल पता दर्ज करें।',
    phoneRequired: 'फ़ोन नंबर आवश्यक है।',
    phoneInvalid: 'फ़ोन नंबर 10 से 15 अंकों का होना चाहिए।',
    dobRequired: 'जन्म तिथि आवश्यक है।',
    dobInvalid: 'कृपया मान्य जन्म तिथि दर्ज करें (YYYY-MM-DD)।',
    genderRequired: 'लिंग आवश्यक है।',
    addressRequired: 'पता आवश्यक है।',
    cityRequired: 'शहर आवश्यक है।',
    cityInvalid: 'शहर केवल अक्षरों, स्पेस, अपॉस्ट्रॉफी या हाइफ़न में होना चाहिए।',
    stateRequired: 'राज्य आवश्यक है।',
    stateInvalid: 'राज्य केवल अक्षरों, स्पेस, अपॉस्ट्रॉफी या हाइफ़न में होना चाहिए।',
    countryRequired: 'देश आवश्यक है।',
    countryInvalid: 'देश केवल अक्षरों, स्पेस, अपॉस्ट्रॉफी या हाइफ़न में होना चाहिए।',
    pincodeRequired: 'पिनकोड आवश्यक है।',
    pincodeInvalid: 'पिनकोड 4 से 10 अंकों का होना चाहिए।',
    emergencyContactRequired: 'आपातकालीन संपर्क नंबर आवश्यक है।',
    emergencyContactInvalid: 'आपातकालीन संपर्क नंबर 10 से 15 अंकों का होना चाहिए।',
    relationshipRequired: 'रिश्ता आवश्यक है।',
    relationshipInvalid: 'कृपया आपातकालीन संपर्क के लिए मान्य रिश्ता चुनें।',
    emergencyCountryCodeRequired: 'आपातकालीन देश कोड आवश्यक है।',
    fixErrorsBeforeSaving: 'कृपया हाइलाइट किए गए फ़ील्ड्स की जाँच करें और प्रोफ़ाइल सहेजने से पहले सभी त्रुटियों को ठीक करें।',
  },
  account: {
    goodMorning: "सुप्रभात",
    goodAfternoon: "नमस्कार",
    goodEvening: "शुभ संध्या",
    completeIdentity: "अपनी पहचान सत्यापित करें",
    addEmergencyContact: "आपातकालीन संपर्क जानकारी जोड़ें",
    uploadDriverLicense: "राइडर प्रोफ़ाइल के लिए ड्राइवर लाइसेंस अपलोड करें",
    aboutYou: "आपके बारे में",
    aboutYouDesc: "अपने बारे में बताएं",
    identityVerification: "पहचान सत्यापन",
    identityVerificationDesc: "अपनी पहचान सत्यापित करें",
    offerRides: "राइड ऑफर करें",
    offerRidesDesc: "अपनी ड्राइवर प्रोफ़ाइल सेट करें",
    findRides: "राइड खोजें",
    findRidesDesc: "आपकी यात्रा प्राथमिकताएँ",
    appSettings: "ऐप सेटिंग्स",
    appSettingsDesc: "अपने अनुभव को अनुकूलित करें",
    walletPayments: "वॉलेट और भुगतान",
    walletPaymentsDesc: "अपने पैसे का प्रबंधन करें",
    supportGrievances: "सहायता और शिकायतें",
    supportGrievancesDesc: "सहायता प्राप्त करें या शिकायत दर्ज करें",
    actionRequired: "कार्रवाई आवश्यक",
    completeProfile: "अपनी प्रोफ़ाइल पूरी करें",
    profileHelp: "अपनी प्रोफ़ाइल पूरी करके हमारी AI को आपके लिए उपयुक्त राइड खोजने में मदद करें!",
  },
  settings: {
    appSettings: 'ऐप सेटिंग्स',
    appSettingsDesc: 'अपने Duri  अनुभव को अनुकूलित करें और अपनी गोपनीयता प्राथमिकताएँ प्रबंधित करें।',
    languageRegion: 'भाषा और क्षेत्र',
    languagePrompt: 'आप किस भाषा को पसंद करेंगे?',
    timezone: 'समय क्षेत्र',
    currency: 'मुद्रा',
    appPermissions: 'ऐप अनुमतियाँ',
    appPermissionsDesc: 'ये अनुमतियाँ हमें आपको सर्वोत्तम राइड अनुभव प्रदान करने में मदद करती हैं। आप इन्हें कभी भी बदल सकते हैं।',
    locationAccess: 'स्थान एक्सेस',
    locationAccessDesc: 'आसपास की राइड्स दिखाने और नेविगेशन के लिए अनुमति दें',
    readSmsOtp: 'एसएमएस/ओटीपी पढ़ें',
    readSmsOtpDesc: 'तेज़ सत्यापन के लिए ओटीपी कोड स्वतः भरें',
    phoneCalls: 'फोन कॉल्स',
    phoneCallsDesc: 'समन्वय के लिए राइडर्स/यात्रियों को कॉल करने की अनुमति दें',
    notifications: 'सूचनाएँ',
    notificationsDesc: 'अपनी राइड्स और Duri  समाचार के बारे में अपडेट रहने का तरीका चुनें।',
    pushNotifications: 'पुश सूचनाएँ',
    pushNotificationsDesc: 'राइड अपडेट्स, संदेश और महत्वपूर्ण अलर्ट',
    emailNotifications: 'ईमेल सूचनाएँ',
    emailNotificationsDesc: 'ईमेल के माध्यम से राइड पुष्टिकरण और रसीदें',
    smsNotifications: 'एसएमएस सूचनाएँ',
    smsNotificationsDesc: 'टेक्स्ट संदेश के माध्यम से महत्वपूर्ण राइड अपडेट्स',
    rideReminders: 'राइड रिमाइंडर',
    rideRemindersDesc: 'आगामी राइड्स के बारे में रिमाइंडर',
    promotionalUpdates: 'प्रमोशनल अपडेट्स',
    promotionalUpdatesDesc: 'विशेष ऑफ़र और नई सुविधाएँ',
    saveSettings: 'सेटिंग्स सहेजें',
  },
  header: {
    home: 'होम',
    findRide: 'राइड खोजें',
    offerRide: 'राइड ऑफर करें',
    manageRides: 'राइड्स प्रबंधित करें',
    account: 'खाता',
    logout: 'लॉगआउट',
    aiAssistant: 'चलो एआई सहायक',
    findPerfectRideMatch: 'अपनी परफेक्ट राइड खोजें',
    connectWithTravelers: 'अपने मार्ग पर यात्रियों से जुड़ें',
    askAiFindingRides: 'राइड खोजने के लिए AI से पूछें...',
    askAiOfferingRides: 'राइड ऑफर करने के लिए AI से पूछें...',
    findRidesToBandra: 'बांद्रा के लिए राइड्स खोजें',
    cheapestRouteToAirport: 'एयरपोर्ट के लिए सबसे सस्ता मार्ग',
    dailyCommuteToPowai: 'पवई के लिए दैनिक यात्रा',
    postRideToGurgaon: 'गुड़गांव के लिए राइड पोस्ट करें',
    setRecurringRoute: 'आवर्ती मार्ग सेट करें',
    managePassengers: 'यात्रियों का प्रबंधन करें',
    benefits: 'लाभ',
    howItWorks: 'कैसे काम करता है',
    findARide: 'राइड खोजें',
    safety: 'सुरक्षा',
    support: 'सहायता',
    login: 'लॉगिन',
    getStarted: 'शुरू करें',
  },
  appStore: {
    title: 'हमारा मोबाइल ऐप प्राप्त करें',
    description: 'चलते-फिरते सर्वश्रेष्ठ राइड-शेयरिंग का अनुभव करें। लाइव ट्रैकिंग, त्वरित सूचनाएँ और सीमलेस बुकिंग के लिए अभी डाउनलोड करें।',
    getItOn: 'पर प्राप्त करें',
    googlePlay: 'गूगल प्ले',
    downloadOnThe: 'पर डाउनलोड करें',
    appStore: 'ऐप स्टोर',
    thanksForJoining: 'समुदाय में शामिल होने के लिए धन्यवाद!',
    communityMessage1: 'राइड शेयरिंग के भविष्य का अनुभव करें',
    communityMessage2: 'हमारा ऐप डाउनलोड करें और हजारों यात्रियों के साथ जुड़ें',
    ctaMessage: 'iOS और Android पर उपलब्ध • डाउनलोड करने के लिए निःशुल्क',
    featuresTitle: 'आज ही योजना बनाएं, हर पर्व का आनंद लें',
    featuresSubtitle: 'सत्यापित मेहमानों और मेजबानों के माध्यम से सुरक्षित और सुरक्षित यात्रा',
    liveTrackingTitle: 'शहर से शहर की राइड्स',
    liveTrackingDesc: 'जीपीएस के साथ अपनी राइड को वास्तविक समय में ट्रैक करें।',
    sosSupportTitle: 'लागत साझा करें',
    sosSupportDesc: '24/7 आपातकालीन समर्थन आपकी उंगलियों पर।',
    perSeatPriceTitle: 'प्रति सीट बुकिंग',
    perSeatPriceDesc: 'केवल अपनी सीट के लिए भुगतान करें। पारदर्शी मूल्य निर्धारण।',
    privatevehicle: 'निजी वाहन',
    privatevehicleDesc: 'अपनी कार में अपने ड्राइवर के साथ यात्रा करें।',
    verifiedCommunityTitle: 'सत्यापित समुदाय',
    verifiedCommunityDesc: 'सत्यापित मेजबानों और मेहमानों के साथ यात्रा करें। हमारा सुरक्षा-प्रथम दृष्टिकोण हर यात्रा पर मन की शांति सुनिश्चित करता है।',
    anytimeRidesTitle: 'कभी भी राइड्स',
    anytimeRidesDesc: '24/7 राइड्स खोजें। चाहे सुबह की जल्दी हो या रात की देर, अपने रास्ते जाने वाले यात्रियों से जुड़ें।',
    instantBookingTitle: 'तत्काल बुकिंग',
    instantBookingDesc: 'अपनी राइड को सेकंडों में बुक करें। हassle-free यात्रा के लिए त्वरित पुष्टिकरण और सीमलेस भुगतान प्रक्रिया।',
    firstRideOfferBadge: '50% छूट',
    firstRideOfferTitle: 'आपकी पहली राइड पर!',
    firstRideOfferDesc: 'Duri पर नए हैं? अपनी पहली राइड पर 50% छूट प्राप्त करें!',
    referralRewardTitle: 'एकाधिक रिवॉर्ड्स कमाएं!',
    referralRewardDesc: 'अपना ऑनबोर्डिंग पूरा करके ₹125 प्राप्त करें और प्रत्येक सफल रेफरल के लिए ₹100 कमाएं। आज ही कमाना शुरू करें!',
    onboardingRewardTitle: 'ऑनबोर्डिंग रिवॉर्ड',
    onboardingRewardDesc: 'जब आप पंजीकरण करते हैं, दस्तावेज़ अपलोड करते हैं, सत्यापन हो जाता है, और कम से कम एक गेस्ट के साथ अपनी पहली होस्ट की गई राइड पूरी करते हैं तो ₹125 कमाएं।',
    referralProgramTitle: 'रेफरल रिवॉर्ड',
    referralProgramDesc: 'प्रत्येक मित्र के लिए ₹100 कमाएं जो ऐप इंस्टॉल करता है, आपका नंबर दर्ज करता है, दस्तावेज़ अपलोड करता है, सत्यापन हो जाता है, और अपनी पहली होस्ट की गई राइड पूरी करता है।',
    limitedTimeOffer: 'सीमित समय का प्रस्ताव',
    noCodeNeeded: 'कोड की आवश्यकता नहीं',
    applyAutomatically: 'स्वचालित रूप से लागू होता है',
  },
  footer: {
    downloadAppTitle: 'Duri डाउनलोड करें',
    downloadAppDesc: 'सर्वश्रेष्ठ अनुभव के लिए मोबाइल ऐप प्राप्त करें, जिसमें लाइव ट्रैकिंग, त्वरित सूचनाएँ और चलते-फिरते राइड बुकिंग शामिल है। सभी डिवाइस पर निःशुल्क उपलब्ध।',
    getItOn: 'पर प्राप्त करें',
    googlePlay: 'गूगल प्ले',
    downloadOnThe: 'डाउनलोड करें',
    appStore: 'ऐप स्टोर',
    scanForAndroid: 'एंड्रॉइड के लिए स्कैन करें',
    scanForIOS: 'iOS के लिए स्कैन करें',
    googlePlayStore: 'गूगल प्ले स्टोर',
    appleAppStore: 'एप्पल ऐप स्टोर',
    brandDesc: 'स्मार्ट, सुरक्षित और टिकाऊ राइड शेयरिंग के माध्यम से दुनिया भर के यात्रियों को जोड़ना। लाखों लोग जो यात्रा का बेहतर तरीका खोज चुके हैं, उनसे जुड़ें और पैसे बचाएं व हमारे ग्रह की रक्षा करें।',
    contactEmail: 'contact@hansaitechnosoft.com',
    contactPhone: '+91 76809 38741',
    contactHours: 'Available hrs: 8 AM to 10 PM IST',
    availableCountries: '25+ देशों में उपलब्ध',
    sectionCompany: 'कंपनी',
    sectionGuests: 'गेस्ट के लिए',
    sectionHosts: 'होस्ट के लिए',
    sectionTravelers: 'यात्रियों के लिए',
    sectionSupport: 'सहायता और सपोर्ट',
    sectionLegal: 'कानूनी और अनुपालन',
    sectionCountries: 'उपलब्ध देश',
    companyLinks: {
      aboutUs: 'हमारे बारे में',
      news: 'समाचार और अपडेट',
      howItWorks: 'यह कैसे काम करता है',
      safety: 'सुरक्षा',
      careers: 'करियर',
      press: 'प्रेस',
      duriGreenMobility: 'ड्यूरी ग्रीन मोबिलिटी',
    },
    guestLinks: {
      howToBook: 'राइड कैसे बुक करें?',
      findARide: 'राइड खोजें',
      availableRides: 'उपलब्ध राइड्स',
      searchByRideId: 'राइड Id से खोजें',
      searchByRider: 'राइडर से खोजें',
      howToBookGuide: 'राइड कैसे बुक करें',
      howToDailyCommute: 'डेली कम्यूट कैसे करें',
      commuteCalculator: 'कम्यूट कैलकुलेटर (गेस्ट)',
    },
    hostLinks: {
      howToHost: 'राइड कैसे होस्ट करें?',
      rideRequests: 'राइड अनुरोध',
      lookUpARide: 'राइड देखें',
      howToDailyCommute: 'डेली कम्यूट कैसे करें',
      popularRoutes: 'लोकप्रिय राइड्स',
      commuteCalculator: 'कम्यूट कैलकुलेटर (होस्ट)',
    },
    travelersLinks: {
      findRides: 'राइड खोजें',
      offerRides: 'राइड ऑफर करें',
      mobileApp: 'मोबाइल ऐप',
      referFriends: 'मित्रों को रेफर करें',
      helpCenter: 'सहायता केंद्र'
    },
    supportLinks: {
      customerSupport: 'ग्राहक सहायता',
      safetyGuidelines: 'सुरक्षा दिशानिर्देश',
      trustSafety: 'विश्वास और सुरक्षा',
      insurance: 'बीमा',
      contactUs: 'संपर्क करें',
      getHelp: 'सहायता प्राप्त करें',
      reportIssue: 'समस्या रिपोर्ट करें',
      myIssues: 'मेरे सपोर्ट टिकट',
      whatsappSupport: 'WhatsApp सपोर्ट',
      corporateCarpool: 'कॉर्पोरेट कारपूल',
    },
    legalLinks: {
      termsOfService: 'नियम और शर्तें',
      privacyPolicy: 'गोपनीयता नीति',
      cookiePolicy: 'कुकी नीति',
      refundPolicy: 'रद्दीकरण नीति',
      deleteAccount: 'खाता हटाएं',
      tripInsurance: 'ट्रिप इंश्योरेंस',
      paymentTerms: 'भुगतान नियम और शर्तें',
      communityGuidelines: 'समुदाय दिशानिर्देश'
    },
    copyright: '© 2025 Duri. सर्वाधिकार सुरक्षित।',
    copyrightText: '@{year} HansAI Techno Soft Private Limited, सर्वाधिकार सुरक्षित'
  },
  howItWorks: {
    sectionTitle: 'कैसे काम करता है',
    sectionSubtitle: 'अपनी यात्रा का अनुभव बदलने के लिए चार आसान कदम — होस्ट के रूप में।',
    searchTitle: 'अपनी राइड लिस्ट करें',
    searchDesc: 'बस कुछ क्लिक में अपनी खाली सीटें और रास्ते गेस्ट को दिखाएँ।',
    connectTitle: 'जुड़ें',
    connectDesc: 'बुकिंग की पुष्टि करने और यात्रा को सुचारू बनाने के लिए गेस्ट से संवाद करें।',
    payTitle: 'कमाएँ',
    payDesc: 'प्रत्येक साझा राइड के लिए सुरक्षित रूप से भुगतान प्राप्त करें और अपने वाहन का अधिकतम उपयोग करें।',
    travelTitle: 'ड्राइव करें',
    travelDesc: 'रियल-टाइम ट्रैकिंग और गेस्ट रेटिंग्स जैसी सुविधाओं के साथ सुरक्षित और भरोसेमंद राइड्स प्रदान करें।',
    GuestsectionSubtitle: 'अपनी यात्रा का अनुभव बदलने के लिए चार आसान कदम — गेस्ट के रूप में।',
    GuestsearchTitle:'खोजें',
    GuestsearchDesc:'अपनी यात्रा मार्ग और समय के अनुसार, वेरिफ़ाइड होस्ट द्वारा दी गई राइड्स आसानी से खोजें।',
    GuestconnectTitle:'जुड़ें',
    GuestconnectDesc:'पिक-अप पॉइंट्स और यात्रा विवरण को सुरक्षित रूप से समन्वयित करने के लिए होस्ट से सीधे चैट करें।',
    GuestpayTitle:'भुगतान करें',
    GuestpayDesc:'अपनी राइड बुक करें और आसानी से लागत बाँटते हुए सुरक्षित रूप से भुगतान करें।',
    GuesttravelTitle:'यात्रा करें',
    GuesttraveDesc:'रियल-टाइम ट्रैकिंग और राइड सपोर्ट के साथ आरामदायक और सुरक्षित यात्रा का आनंद लें।'
  },
  safety: {
    badge: 'आपकी सुरक्षा पहले',
    sectionTitle: 'विश्वास',
    sectionTitleHighlight: 'सत्यापित कनेक्शनों के साथ',
    sectionSubtitle: 'सुरक्षित यात्रा, भरोसेमंद और अनुकूल राइड अनुभव सुनिश्चित करने के लिए हमारे विश्वसनीय राइड शेयरिंग ऐप पर प्रत्येक उपयोगकर्ता सत्यापित है।',
    idVerificationTitle: 'सरकारी आईडी सत्यापन',
    idVerificationDesc: 'सभी उपयोगकर्ताओं को आधार, पैन या ड्राइविंग लाइसेंस जैसे सरकारी दस्तावेज़ों से अपनी पहचान सत्यापित करनी होती है',
    idVerificationStats: '100% आईडी सत्यापित उपयोगकर्ता',
    professionalTitle: 'पेशेवर पृष्ठभूमि',
    professionalDesc: 'हम पारदर्शिता के लिए कार्य इतिहास, कंपनी विवरण और पेशेवर संदर्भों की जांच करते हैं',
    professionalStats: '95% पेशेवर सत्यापित',
    cultureTitle: 'संस्कृति और भाषा मिलान',
    cultureDesc: 'सांस्कृतिक प्राथमिकताओं, बोली जाने वाली भाषाओं और क्षेत्रीय परिचय के आधार पर स्मार्ट मिलान',
    cultureStats: '90% अनुकूलता स्कोर',
    interestsTitle: 'रुचियां और शौक',
    interestsDesc: 'ऐसे यात्रियों से जुड़ें जिनकी रुचियां और जीवनशैली समान हो',
    interestsStats: '85% रुचि मेल',
    trackingTitle: 'रीयल-टाइम ट्रैकिंग',
    trackingDesc: 'हर यात्रा के लिए रियल-टाइम राइड ट्रैकिंग और स्मार्ट मोबिलिटी सॉल्यूशन्स के साथ सुरक्षित रहें|',
    trackingStats: '24/7 सुरक्षा निगरानी',
    secureCommTitle: 'सुरक्षित संचार',
    secureCommDesc: 'सत्यापित होस्ट्स और मेहमानों के लिए हमारे ऐप पर सुरक्षित संचार का आनंद लें — गोपनीयता की गारंटी।',
    secureCommStats: 'बैंक-स्तरीय एन्क्रिप्शन',
    backgroundVerified: 'पृष्ठभूमि सत्यापित',
    safeRidesCompleted: 'सुरक्षित यात्राएं पूरी हुईं',
    trustScoreAverage: 'औसत विश्वास स्कोर',
    emergencyResponse: 'आपातकालीन प्रतिक्रिया',
    ctaTitle: 'क्या आप सुरक्षित यात्रा के लिए तैयार हैं?',
    ctaDesc: 'हमारे सत्यापित समुदाय से जुड़ें और सबसे सुरक्षित राइड शेयरिंग का अनुभव लें।',
    ctaButton: 'सत्यापन प्रक्रिया शुरू करें',
  },
  hero: {
    badge: 'हमारे सत्यापित राइडशेयरिंग प्लेटफ़ॉर्म पर 10 मिलियन से अधिक मेहमानों का विश्वास',
    mainTitle: 'राइड साझा करें, बचत करें',
    mainTitleHighlight: 'पैसा और पर्यावरण',
    subtitle: 'सबसे विश्वसनीय इंटरसिटी राइडशेयरिंग ऐप से जुड़ें — अपनी सवारी साझा करें, अधिक बचत करें, और समझदारी से यात्रा करें।',
    findRide: 'राइड खोजें',
    offerRide: 'राइड ऑफर करें',
    statSaved: 'कुल बचत',
    statCO2: 'CO₂ टन उत्सर्जन में कमी',
    statHappy: 'खुश यात्राएं',
  },
  statistics: {
    sectionTitle: 'हमारा प्रभाव',
    sectionSubtitle: 'असली यात्रियों के असली आंकड़े, असली बदलाव के लिए।',
    travelersLabel: 'यात्री',
    travelersDesc: 'Duri पर भरोसा करते हैं',
    citiesLabel: 'शहर',
    citiesDesc: 'वैश्विक रूप से जुड़े',
    savedLabel: 'बचत',
    savedDesc: 'हमारे समुदाय द्वारा',
    co2Label: 'टन CO₂',
    co2Desc: 'उत्सर्जन की बचत — सर्वोत्तम कार्बन-बचत यात्रा समाधान',
    costReductionLabel: 'लागत में कमी',
    costReductionSuffix: '% बनाम अकेली यात्रा',
    emissionReductionLabel: 'उत्सर्जन में कमी',
    emissionReductionSuffix: '% बनाम व्यक्तिगत कारें',
    userSatisfactionLabel: 'उपयोगकर्ता संतुष्टि',
    userSatisfactionSuffix: '% अनुशंसा करेंगे',
    safetyRateLabel: 'सुरक्षा दर',
    safetyRateSuffix: '% बिना घटना के',
  },
  benefits: {
    badge: 'क्यों Duri?',
    sectionTitle: 'आपकी हर जरूरत',
    sectionSubtitle: 'स्मार्ट, सुरक्षित और टिकाऊ यात्रा के लिए।',
    saveMoneyTitle: 'पैसे बचाएं',
    saveMoneyDesc: 'कम लागत वाली राइडशेयरिंग विकल्पों के साथ बजट यात्रा का आनंद लें, जो खर्चों को 70% तक कम करती हैं',
    saveMoneyStats: '₹15,000 औसत वार्षिक बचत',
    helpPlanetTitle: 'पृथ्वी की मदद करें',
    helpPlanetDesc: 'हर साझा ट्रैवल ऐप राइड के साथ CO₂ को कम करें और एक हरित यात्रा समाधान चुनें',
    helpPlanetStats: '2.3 किग्रा CO₂ प्रति 100 किमी बचत',
    travelSafeTitle: 'सुरक्षित यात्रा',
    travelSafeDesc: 'सत्यापित होस्ट और रियल-टाइम राइड ट्रैकिंग वाली एक विश्वसनीय कारपूल ऐप',
    travelSafeStats: '99.8% बिना घटना के राइड्स',
    anyTimeTitle: 'कभी भी',
    anyTimeDesc: 'हमारे रियल-टाइम नेविगेशन ऐप के साथ कभी भी सिटी-टू-सिटी राइड्स तक पहुँचें',
    anyTimeStats: 'हर समय उपलब्ध',
    meetPeopleTitle: 'लोगों से मिलें',
    meetPeopleDesc: 'हमारी बढ़ती हुई राइड शेयरिंग कम्युनिटी के माध्यम से जुड़ें और साथ में यात्रा करें',
    meetPeopleStats: '85% उपयोगकर्ताओं ने कनेक्शन बनाए',
    goAnywhereTitle: 'कहीं भी जाएं',
    goAnywhereDesc: 'कई देशों में 500+ गंतव्यों तक पहुंच',
    goAnywhereStats: '500+ शहरों में उपलब्ध',
  },
  testimonials: {
    sectionTitle: 'हमारे समुदाय की कहानियां',
    sectionSubtitle: 'असली यात्रियों के असली अनुभव जिन्होंने साझा यात्रा का आनंद लिया।',
    averageRating: 'औसत रेटिंग',
    recommendUs: 'हमें अनुशंसा करते हैं',
    happyTravelers: 'खुश यात्री',
    customerSupport: 'ग्राहक सहायता',
    trustedBy: 'इन कंपनियों के कर्मचारी भी भरोसा करते हैं',
    items: [
      JSON.stringify({
        name: 'प्रिया शर्मा',
        role: 'सॉफ्टवेयर इंजीनियर',
        location: 'मुंबई → पुणे मार्ग',
        rating: 5,
        text: 'मैंने पिछले 6 महीनों में अपनी साप्ताहिक मुंबई-पुणे यात्राओं के लिए राइडशेयरिंग का उपयोग करके ₹8,000 से अधिक बचाया है। यह ऐप सत्यापित होस्ट और सरल बुकिंग के साथ सबसे विश्वसनीय कारपूल ऐप है।',
        avatar: '👩‍💼',
        savings: '₹8,000 बचत'
      }),
      JSON.stringify({
        name: 'राज पटेल',
        role: 'व्यवसायी',
        location: 'दिल्ली → जयपुर मार्ग',
        rating: 5,
        text: 'मैं हर महीने दो बार व्यापार के लिए जयपुर जाता हूँ, यह प्लेटफॉर्म मेरे लिए गेम-चेंजर रहा है। शानदार कंपनी, विश्वसनीय सेवा, और मैं पर्यावरण की भी मदद कर रहा हूँ!',
        avatar: '👨‍💼',
        savings: '60% लागत में कमी'
      }),
      JSON.stringify({
        name: 'अनीता रेड्डी',
        role: 'कॉलेज छात्रा',
        location: 'बेंगलुरु → चेन्नई मार्ग',
        rating: 5,
        text: 'दैनिक आवागमन खर्च बचाने के लिए कम लागत वाली यात्रा ऐप की तलाश कर रहे छात्रों और पेशेवरों के लिए उपयुक्त। अब मैं घर अधिक बार जा सकती हूँ। सुरक्षा फीचर्स से मेरे माता-पिता निश्चिंत रहते हैं, और मैंने कई अच्छे दोस्त भी बनाए हैं।',
        avatar: '👩‍🎓',
        savings: '₹12,000 वार्षिक बचत'
      }),
      JSON.stringify({
        name: 'विक्रम सिंह',
        role: 'मार्केटिंग मैनेजर',
        location: 'हैदराबाद → विजयवाड़ा मार्ग',
        rating: 5,
        text: 'सह-यात्रियों की गुणवत्ता शानदार है। अच्छे संवाद हुए और बिजनेस नेटवर्किंग के मौके भी मिले। अब यह सिर्फ पैसे बचाने के लिए नहीं है।',
        avatar: '👨‍💻',
        savings: 'नए कनेक्शन'
      })
    ]
  },
  quickRideFinder: {
    currentLocationDetected: '📍 वर्तमान स्थान पहचाना गया',
    greeting1: '👋 नमस्ते! आप {location} में हैं।',
    greeting2: 'आज आप कहाँ जाना चाहेंगे?',
    letsFindRide: 'चलो राइड खोजें! ✨',
    destinationPrompt: '🎯 शानदार! अब कहाँ चलें?',
    destinationSubPrompt: 'अपना गंतव्य टाइप करें या नीचे से चुनें',
    destinationPlaceholder: 'जैसे, पुणे, दिल्ली, बैंगलोर...',
    nextWhen: 'अगला: कब? →',
    datePrompt: '📅 बढ़िया चुनाव! {from} से {to}',
    dateSubPrompt: 'आप कब यात्रा करना चाहेंगे?',
    nextPassengers: 'अगला: कितने यात्री? →',
    passengersPrompt: '👥 लगभग हो गया! कितने यात्री?',
    passengersSubPrompt: 'खुद को शामिल करें',
    perfectFindRides: 'सही! चलिए राइड्स खोजते हैं →',
    readyTitle: '🎉 खोज के लिए तैयार!',
    from: 'से:',
    to: 'तक:',
    date: 'तारीख:',
    passengers: 'यात्री:',
    person: 'व्यक्ति',
    people: 'लोग',
    findMyPerfectRide: 'मेरी परफेक्ट राइड खोजें!',
      popularRoutes: 'मुम्बई से लोकप्रिय मार्ग', // {city}
    today: 'आज',
    tomorrow: 'कल',
    thisWeekend: 'इस सप्ताहांत',
    locationNotFoundLabel: '📍 स्थान नहीं मिला',
    locationNotFoundMessage: 'कृपया स्थान एक्सेस सक्षम करें या आरंभ करने के लिए अपना स्थान मैन्युअल रूप से दर्ज करें!',
  },
  topBar: {
    welcomeMessage: "ड्यूरि राइडशेयरिंग में आपका स्वागत है — सत्यापित गेस्ट और होस्ट के साथ सुरक्षित और भरोसेमंद यात्रा",
  },
};
export default hi; 